import {DistinctDomain} from 'antibodies/AntibodyTypedefs';
import * as TaskRunner from 'util/TaskRunner';

export interface DefinedConstantDomainEntity extends DistinctDomain {
  aaSequenceId: string;
}

/**
 * Creates antibodies from the provided DNA pair IDs.
 *
 * @param dnaPairIds - List of API IDs for DNA pairs to convert to antibodies
 * @param constantDomains - List of which AA sequences to use as the constant domains
 * @param folderId - folder where all new entities will be created
 */
export function createAntibodiesFromDnaPairs(
  dnaPairIds: Array<string>,
  constantDomains: Array<DefinedConstantDomainEntity>,
  folderId: string
): Promise<{}> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/antibodies/nested-data-creation/dna-pairs-to-antibodies:create',
    data: {
      dnaPairIds,
      constantDomains,
      folderId,
    },
  });
}
